var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuicktradeLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2816 24.9351C27.8508 24.1894 28.3271 23.3689 28.6933 22.4911C29.2388 21.1836 29.54 19.7488 29.54 18.2436C29.54 12.1467 24.5974 7.2041 18.5005 7.2041C12.4035 7.2041 7.46094 12.1467 7.46094 18.2436C7.46094 24.3406 12.4035 29.2832 18.5005 29.2832C20.273 29.2832 21.948 28.8654 23.4324 28.123L27.2816 30.5161",
    stroke: "#111219",
    strokeWidth: 2.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2194 17.2876H19.2356L19.8235 12.9121C19.8262 12.8914 19.822 12.8704 19.8116 12.8523C19.8012 12.8342 19.7851 12.8201 19.7658 12.812C19.7466 12.804 19.7252 12.8025 19.7051 12.8078C19.6849 12.8131 19.667 12.8248 19.6542 12.8413L14.599 19.3857C14.5726 19.4199 14.5563 19.4609 14.5519 19.504C14.5476 19.5471 14.5554 19.5905 14.5745 19.6294C14.5936 19.6682 14.6232 19.701 14.66 19.7239C14.6967 19.7468 14.7391 19.7589 14.7824 19.7589H17.7662L17.1784 24.1345C17.1757 24.1552 17.1799 24.1762 17.1903 24.1942C17.2007 24.2123 17.2168 24.2265 17.236 24.2345C17.2552 24.2426 17.2766 24.244 17.2968 24.2388C17.317 24.2335 17.3348 24.2217 17.3477 24.2053L22.4028 17.6609C22.4293 17.6266 22.4456 17.5856 22.4499 17.5425C22.4542 17.4995 22.4464 17.456 22.4273 17.4172C22.4082 17.3783 22.3786 17.3456 22.3419 17.3227C22.3051 17.2998 22.2627 17.2877 22.2194 17.2876Z",
    fill: "#863DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicktradeLight);
export default __webpack_public_path__ + "static/media/quicktrade_light.9ba27c33c1ce81c5138a5ebaa486712e.svg";
export { ForwardRef as ReactComponent };